/**
 *  @class
 *  @function ProductShowcaseSlider
 */
if (!customElements.get('product-showcase-slider')) {
  class ProductShowcaseSlider extends HTMLElement {
    constructor() {
      super();
      const productShowcaseSlider = this,
        tabbedContent = productShowcaseSlider.querySelector("tabbed-content"),
        tabButtons = tabbedContent.querySelectorAll(".tabbed-content--tabs button"),
        mobileFilterSummary = productShowcaseSlider.querySelector(".mobile-filter-overview"),
        filteredContent = productShowcaseSlider.querySelector(".filtered-content"),
        collapsibleRows = productShowcaseSlider.querySelectorAll("collapsible-row"),
        collapsibleRowsButtons = productShowcaseSlider.querySelectorAll("collapsible-row button");

      tabbedContent.querySelectorAll(".container-nav-dot,.chevron-nav").forEach(nav => {
        nav.addEventListener("click", function () {
          tabbedContent.querySelector(".tabbed-content--tabs button[data-tab-index='" + nav.dataset.refTabIndex + "']").click();
        });
      })

      tabButtons.forEach(btn => {
        btn.addEventListener("click", function (e) {
          if (btn.classList.contains("active")) return;
          productShowcaseSlider.dispatchEvent(new CustomEvent("expert:changed", {
            "detail": {
              "tab": btn.dataset.tabIndex
            }
          }));
          mobileFilterSummary.querySelector("tab-label").innerText = btn.textContent.replace(/\n/g, "").trim()
        });
      });
      productShowcaseSlider.addEventListener("expert:changed", async function (e) {
        collapsibleRows.forEach(row => {
          if (
            (row.dataset.refTabIndex != e.detail.tab && row.querySelector("details").hasAttribute("open")) ||
            (row.dataset.refTabIndex == e.detail.tab && !row.querySelector("details").hasAttribute("open"))
          ) row.querySelector("summary").click()
        });

        productShowcaseSlider.querySelector(".slide-show-container.active").classList.remove("active");
        productShowcaseSlider.querySelectorAll(".slide-show-container")[e.detail.tab].classList.add("active");

        await new Promise(r => setTimeout(r, 10));
        if (!collapsibleRows[e.detail.tab].querySelector("button[data-clicked='true']"))
          collapsibleRows[e.detail.tab].querySelector("button").click();
      });

      mobileFilterSummary.addEventListener("click", function () {
        this.classList.toggle("active");
      })
      collapsibleRowsButtons.forEach(btn => {
        btn.addEventListener("click", async function () {
          if (btn.dataset.clicked === "true") return;
          let currentRefTabIndex = productShowcaseSlider.querySelector("collapsible-row button[data-clicked='true']").closest("collapsible-row").dataset.refTabIndex;
          productShowcaseSlider.querySelector("collapsible-row button[data-clicked='true']").dataset.clicked = false;
          mobileFilterSummary.querySelector("tab-label").setAttribute("selected-filter", btn.textContent.replace(/\n/g, "").trim());
          btn.dataset.clicked = true;
          productShowcaseSlider.dispatchEvent(new CustomEvent("expert:category-changed", {
            "detail": {
              "category": btn.dataset.sublabelId,
              "tab": btn.closest("collapsible-row").dataset.refTabIndex,
              "skipCategoryChange": btn.closest("collapsible-row").dataset.refTabIndex == currentRefTabIndex
            }
          }));
          mobileFilterSummary.classList.contains('active') && mobileFilterSummary.click();
        });
      });
      productShowcaseSlider.addEventListener("expert:category-changed", function (e) {
        filteredContent.querySelector(".sublabel-filtered-content.active").classList.remove("active");
        filteredContent.querySelector("#" + e.detail.category).classList.add("active");
        productShowcaseSlider.dispatchEvent(new CustomEvent("expert:change-category", {
          "detail": {
            "tab": e.detail.tab,
            "skipCategoryChange": e.detail.skipCategoryChange
          }
        }));
      });
      productShowcaseSlider.addEventListener("expert:change-category", function (e) {
        if (!e.detail.skipCategoryChange)
          tabbedContent.querySelector(".tabbed-content--tabs button[data-tab-index='" + e.detail.tab + "']").click();
      });
    }
  }
  customElements.define('product-showcase-slider', ProductShowcaseSlider);
}